<div provide-parent-form *ngIf="mediaclip">

	<h3 class="mobile">{{ 'METADATA' | translate }}</h3>

	<bb-form-element [form]="form" invalidMessage="The title is required" [required]="!mediaclip?.originalfilename" [label]="'TITLE' | translate">
		<input [(ngModel)]="mediaclip.title" type="text" name="title" />
		<div *ngIf="mediaclip?.title?.length > 0">
			<small>{{ mediaclip.title.length }} {{ 'CHARACTERS' | translate }}</small>
		</div>
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<ng-container *ngIf="!useRichTextDescription">
			<textarea [(ngModel)]="mediaclip.description" type="text" name="mediaclipDescription">{{mediaclip.description}}</textarea>
		</ng-container>
		<ng-container *ngIf="useRichTextDescription">
			<bb-wysiwyg
				[(ngModel)]="mediaclip.description"
				name="mediaclipDescription"
			></bb-wysiwyg>
		</ng-container>
		<div *ngIf="mediaclip?.description?.length > 0">
			<small>{{ mediaclip.description.length }} {{ 'CHARACTERS' | translate }}</small>
		</div>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'AUTHOR' | translate">
		<input [(ngModel)]="mediaclip.author" type="text" name="author"/>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'COPYRIGHT' | translate">
		<input [(ngModel)]="mediaclip.copyright" type="text" name="copyright"/>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'DEEP_LINK' | translate" [helpMessage]="'HELP.DEEP_LINK' | translate" [actionButtonIcon]="'qrcode'" [actionButtonDisabled]="!mediaclip.deeplink && !mediaclip.gendeeplink" (actionButtonClick)="showQrCode()">
		<input [(ngModel)]="mediaclip.deeplink" type="text" name="deeplink" [placeholder]="placeholder"/>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'TAGS' | translate" [helpMessage]="'HELP.TAGS' | translate">
		<bb-entity-selector 
			[(ngModel)]="mediaclip.cat"
			name="mediaclip-tags"
			[entityType]="'mediaclip'"
			[extendable]="true"
			[multi]="true"
			[facet]="'cat'"
		></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'DISABLE_COMMERCIALS' | translate" [helpMessage]="'HELP.DISABLE_COMMERCIALS_MEDIACLIP' | translate">
		<bb-check [(ngModel)]="mediaclip.disablecommercials" name="disablecommercials"></bb-check>
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'USE_AS_CREATIVE' | translate" [helpMessage]="'HELP.USE_AS_CREATIVE' | translate" [hasPermission]="'creative_management'">
		<bb-check [(ngModel)]="mediaclip.usetype" name="useAsCreative" [trueValue]="'commercial'" [falseValue]="'editorial'"></bb-check>
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'USETYPES' | translate" [hasPublicationField]="'manageSubusetype'">
		<bb-entity-selector 
			[(ngModel)]="mediaclip.subusetype"
			name="mediaclip-subusetype"
			[options]="subUseTypeOptions"
			[multi]="true"
		></bb-entity-selector>
		<div
		[hasPermission]="'ad services'"
		[hidden]="mediaclip?.subusetype?.indexOf('vast_creative') === -1"
		style="float: right;">
			<a class="link blue"
				[href]="'#/adservices/vastservice/creatives/' + mediaclip?.id + '/metadata'">
				{{ 'FURTHER_MANAGE_CREATIVE_IN_VAST_SERVICE' | translate }}
			</a>
		</div>
	</bb-form-element>
	
	<bb-form-element *ngIf="mediaclip.mediatype === 'video'" [form]="form" [label]="'IS_DYNAMIC' | translate" [helpMessage]="'HELP.IS_DYNAMIC_MEDIACLIP' | translate" [hasPermission]="'dynamic_rendered_video'">
		<bb-check [(ngModel)]="mediaclip.isDynamic" name="isDynamic"></bb-check>
	</bb-form-element>

	<p *ngIf="customFields" class="divider right-align"><small>{{ 'CUSTOM_FIELDS' | translate }}</small></p>

	<ng-container *ngFor="let field of customFields">
		<bb-form-element [form]="form" [label]="field.label" *ngIf="field.visible">
			<bb-field-renderer
				[(ngModel)]="mediaclip[field.name]"
				[fieldConfig]="field"
				[name]="'custom-' + field.name"
			></bb-field-renderer>
		</bb-form-element>
	</ng-container>
</div>

<ng-template #qrcodeModal>
	<bb-qrcode [entity]="mediaclip" [redirectUrl]="mediaclip?.deeplink || mediaclip?.gendeeplink || placeholder" [qrCodeImgUrl]="qrCodeImageUrl" [hideImageUrl]="true"></bb-qrcode>
</ng-template>
